module.exports = __webpack_public_path__ + "static/media/truck-solid.3712ba6c.svg";